import { render, staticRenderFns } from "./BasicImage.vue?vue&type=template&id=c4f003dc&scoped=true"
import script from "./BasicImage.vue?vue&type=script&lang=js"
export * from "./BasicImage.vue?vue&type=script&lang=js"
import style0 from "./BasicImage.vue?vue&type=style&index=0&id=c4f003dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f003dc",
  null
  
)

export default component.exports